export default __webpack_public_path__ + "static/media/2_archive.31a7acc3.svg";